import { Component, Input } from '@angular/core';
import type { GridApi } from '@ag-grid-community/core';

/**
 * Button component to toggle the AG Grid columns sidebar panel
 * Based on implementation from little-sis-cloud-webapp
 */
@Component({
  selector: 'cdw-column-visibility-button',
  templateUrl: './column-visibility-button.component.html',
  styleUrls: ['./column-visibility-button.component.scss'],
  standalone: true,
  imports: [],
})
export class ColumnVisibilityButtonComponent {
  /**
   * AG Grid API instance
   */
  @Input() gridApi?: GridApi;

  /**
   * Button label text
   */
  @Input() label = 'Columns';

  /**
   * ID of the sidebar tool panel to toggle
   */
  @Input() toolPanelId = 'columns';

  /**
   * Whether to show an icon on the button
   */
  @Input() showIcon = true;

  /**
   * Toggles the visibility of the columns sidebar panel
   */
  toggleColumnPanel(): void {
    if (!this.gridApi) {
      return;
    }

    const isSidebarVisible = this.gridApi.isSideBarVisible();
    const openToolPanel = this.gridApi.getOpenedToolPanel();

    if (isSidebarVisible && openToolPanel === this.toolPanelId) {
      // If the columns panel is already open, close the sidebar
      this.gridApi.closeToolPanel();
    } else {
      // Open the columns panel
      this.gridApi.openToolPanel(this.toolPanelId);
    }
  }

  /**
   * Checks if the columns panel is currently open
   */
  isColumnPanelOpen(): boolean {
    if (!this.gridApi) {
      return false;
    }
    return (
      this.gridApi.isSideBarVisible() &&
      this.gridApi.getOpenedToolPanel() === this.toolPanelId
    );
  }
}
